module.exports = window["redfoxThankYou"]["controls"];